var map = {
	"./admin/account.json": 77066,
	"./admin/addresses.json": 25755,
	"./admin/admin.json": 7933,
	"./admin/algos.json": 75696,
	"./admin/bank.json": 21753,
	"./admin/bds.json": 79691,
	"./admin/boxes.json": 3444,
	"./admin/common.json": 96873,
	"./admin/consultation.json": 49860,
	"./admin/dongle.json": 79950,
	"./admin/emr.json": 68077,
	"./admin/eyes.json": 53433,
	"./admin/keyboard.json": 38142,
	"./admin/login.json": 43948,
	"./admin/logs.json": 95840,
	"./admin/nav.json": 482,
	"./admin/notifications.json": 32850,
	"./admin/opto.json": 43820,
	"./admin/organization.json": 61013,
	"./admin/patient.json": 2581,
	"./admin/practionner.json": 71195,
	"./admin/role.json": 45899,
	"./admin/settings.json": 81629,
	"./admin/shop.json": 98290,
	"./admin/stats.json": 31885,
	"./admin/subscriptions.json": 64519,
	"./admin/table.json": 14274,
	"./admin/test_cases.json": 60796,
	"./admin/tips.json": 67265,
	"./admin/validations.json": 35763,
	"./app_strings.json": 59246,
	"./client/account_client.json": 83045,
	"./client/common_client.json": 95980,
	"./client/console.json": 42536,
	"./client/consultation_client.json": 28934,
	"./client/eyes.json": 14461,
	"./client/nav_client.json": 93101,
	"./client/patient_client.json": 80277,
	"./client/pdf.json": 12589,
	"./client/stats_client.json": 79707
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25781;